// // import React, { useState, useEffect } from "react";
// // import { Form, Input, Button, InputNumber, Space } from "antd";

// // const ProductForm = ({ companyId, product, onSubmit, onCancel, loading }) => {
// //   const [form] = Form.useForm();
// //   const [variants, setVariants] = useState([]);

// //   useEffect(() => {
// //     if (product) {
// //       form.setFieldsValue({
// //         name: product.name || "",
// //         model: product.model || "",
// //         short_description: product.short_description || "",
// //         long_description: product.long_description || "",
// //         price: product.price || "",
// //       });
// //       setVariants(product.variants || []);
// //     } else {
// //       form.resetFields();
// //       setVariants([]);
// //     }
// //   }, [product, form]);

// //   const handleVariantChange = (index, field, value) => {
// //     const newVariants = [...variants];
// //     newVariants[index][field] = value;
// //     setVariants(newVariants);
// //   };

// //   const handleAddVariant = () => {
// //     setVariants([...variants, { name: "", price: "" }]);
// //   };

// //   const handleRemoveVariant = (index) => {
// //     const newVariants = variants.filter((_, i) => i !== index);
// //     setVariants(newVariants);
// //   };

// //   const onFinish = (values) => {
// //     onSubmit({ ...values, variants });
// //   };

// //   return (
// //     <Form form={form} onFinish={onFinish} layout="vertical">
// //       <Form.Item name="name" label="Product Name" rules={[{ required: true }]}>
// //         <Input />
// //       </Form.Item>
// //       <Form.Item name="model" label="Model">
// //         <Input />
// //       </Form.Item>
// //       <Form.Item name="short_description" label="Short Description">
// //         <Input.TextArea rows={2} />
// //       </Form.Item>
// //       <Form.Item name="long_description" label="Long Description">
// //         <Input.TextArea rows={3} />
// //       </Form.Item>
// //       <Form.Item name="price" label="Base Price" rules={[{ required: true }]}>
// //         <InputNumber style={{ width: "100%" }} step="0.01" />
// //       </Form.Item>
// //       <Form.Item label="Variants">
// //         {variants.map((variant, idx) => (
// //           <Space
// //             key={idx}
// //             style={{ display: "flex", marginBottom: 8 }}
// //             align="baseline"
// //           >
// //             <Input
// //               placeholder="Variant Name"
// //               value={variant.name}
// //               onChange={(e) => handleVariantChange(idx, "name", e.target.value)}
// //             />
// //             <InputNumber
// //               placeholder="Variant Price"
// //               value={variant.price}
// //               onChange={(value) => handleVariantChange(idx, "price", value)}
// //               step="0.01"
// //             />
// //             <Button
// //               danger
// //               onClick={() => handleRemoveVariant(idx)}
// //             >
// //               Remove
// //             </Button>
// //           </Space>
// //         ))}
// //         <Button type="dashed" onClick={handleAddVariant} block>
// //           Add Variant
// //         </Button>
// //       </Form.Item>
// //       <Form.Item>
// //         <div style={{ textAlign: "end" }}>
// //           <Button onClick={onCancel} style={{ marginRight: 8 }}>
// //             Cancel
// //           </Button>
// //           <Button type="primary" htmlType="submit" loading={loading}>
// //             {loading ? "Saving..." : product ? "Update Product" : "Add Product"}
// //           </Button>
// //         </div>
// //       </Form.Item>
// //     </Form>
// //   );
// // };

// // export default ProductForm;

// import React, { useState, useEffect } from "react";
// import { Modal } from "antd";

// const ProductFormModal = ({
//   showProductForm,
//   setShowProductForm,
//   selectedCompany,
//   product,
//   setEditingProduct,
//   handleProductSubmit,
//   loading,
// }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     model: "",
//     short_description: "",
//     long_description: "",
//     price: "",
//     variants: [],
//   });

//   // prefill data when editing
//   useEffect(() => {
//     if (product) {
//       setFormData({
//         name: product.name || "",
//         model: product.model || "",
//         short_description: product.short_description || "",
//         long_description: product.long_description || "",
//         price: product.price || "",
//         variants: product.variants || [],
//       });
//     } else {
//       setFormData({
//         name: "",
//         model: "",
//         short_description: "",
//         long_description: "",
//         price: "",
//         variants: [],
//       });
//     }
//   }, [product]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleVariantChange = (index, field, value) => {
//     const updated = [...formData.variants];
//     updated[index][field] = value;
//     setFormData((prev) => ({ ...prev, variants: updated }));
//   };

//   const handleAddVariant = () => {
//     setFormData((prev) => ({
//       ...prev,
//       variants: [...prev.variants, { name: "", price: "" }],
//     }));
//   };

//   const handleRemoveVariant = (index) => {
//     const updated = formData.variants.filter((_, i) => i !== index);
//     setFormData((prev) => ({ ...prev, variants: updated }));
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     handleProductSubmit({ ...formData, companyId: selectedCompany?.id });
//   };

//   const handleCancel = () => {
//     setShowProductForm(false);
//     setEditingProduct(null);
//     setFormData({
//       name: "",
//       model: "",
//       short_description: "",
//       long_description: "",
//       price: "",
//       variants: [],
//     });
//   };

//   return (
//     <Modal
//       title={product ? "Edit Product" : "Add Product"}
//       open={showProductForm}
//       onCancel={handleCancel}
//       footer={null}
//       width={700}
//       className="bootstrap-modal"
//     >
//       <form onSubmit={handleSubmit}>
//         <div className="row">
//           <div className="col-md-6 mb-3">
//             <label className="form-label">Product Name</label>
//             <input
//               type="text"
//               className="form-control"
//               name="name"
//               value={formData.name}
//               onChange={handleInputChange}
//               required
//             />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Model</label>
//             <input
//               type="text"
//               className="form-control"
//               name="model"
//               value={formData.model}
//               onChange={handleInputChange}
//             />
//           </div>

//           <div className="col-12 mb-3">
//             <label className="form-label">Short Description</label>
//             <textarea
//               className="form-control"
//               name="short_description"
//               rows="2"
//               value={formData.short_description}
//               onChange={handleInputChange}
//             />
//           </div>

//           <div className="col-12 mb-3">
//             <label className="form-label">Long Description</label>
//             <textarea
//               className="form-control"
//               name="long_description"
//               rows="3"
//               value={formData.long_description}
//               onChange={handleInputChange}
//             />
//           </div>

//           <div className="col-md-6 mb-3">
//             <label className="form-label">Base Price</label>
//             <input
//               type="number"
//               className="form-control"
//               name="price"
//               step="0.01"
//               value={formData.price}
//               onChange={handleInputChange}
//               required
//             />
//           </div>
//         </div>

//         {/* Variants */}
//         <div className="mb-3">
//           <label className="form-label">Variants</label>
//           {formData.variants.map((variant, idx) => (
//             <div key={idx} className="d-flex gap-2 mb-2">
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Variant Name"
//                 value={variant.name}
//                 onChange={(e) =>
//                   handleVariantChange(idx, "name", e.target.value)
//                 }
//               />
//               <input
//                 type="number"
//                 className="form-control"
//                 placeholder="Variant Price"
//                 step="0.01"
//                 value={variant.price}
//                 onChange={(e) =>
//                   handleVariantChange(idx, "price", e.target.value)
//                 }
//               />
//               <button
//                 type="button"
//                 className="btn btn-outline-danger"
//                 onClick={() => handleRemoveVariant(idx)}
//               >
//                 Remove
//               </button>
//             </div>
//           ))}
//           <button
//             type="button"
//             className="btn btn-outline-primary w-100"
//             onClick={handleAddVariant}
//           >
//             Add Variant
//           </button>
//         </div>

//         <div className="d-flex justify-content-end gap-2 mt-4">
//           <button
//             type="button"
//             className="btn bg-danger-subtle text-danger px-4"
//             onClick={handleCancel}
//           >
//             Cancel
//           </button>
//           <button
//             type="submit"
//             className="btn btn-primary px-4"
//             disabled={loading}
//           >
//             {loading
//               ? "Saving..."
//               : product
//               ? "Update Product"
//               : "Save Product"}
//           </button>
//         </div>
//       </form>
//     </Modal>
//   );
// };

// export default ProductFormModal;


import React, { useState, useEffect } from "react";
import "../../App.css";

const ProductFormModal = ({
  showProductForm,
  setShowProductForm,
  selectedCompany,
  product,
  setEditingProduct,
  handleProductSubmit,
  loading,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    model: "",
    short_description: "",
    long_description: "",
    price: "",
    variants: [],
  });

  // Prefill data when editing
  useEffect(() => {
    if (product) {
      setFormData({
        name: product.name || "",
        model: product.model || "",
        short_description: product.short_description || "",
        long_description: product.long_description || "",
        price: product.price || "",
        variants: product.variants || [],
      });
    } else {
      resetForm();
    }
  }, [product]);

  const resetForm = () => {
    setFormData({
      name: "",
      model: "",
      short_description: "",
      long_description: "",
      price: "",
      variants: [],
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleVariantChange = (index, field, value) => {
    const updated = [...formData.variants];
    updated[index][field] = value;
    setFormData((prev) => ({ ...prev, variants: updated }));
  };

  const handleAddVariant = () => {
    setFormData((prev) => ({
      ...prev,
      variants: [...prev.variants, { name: "", price: "", max_discount: "" }],
    }));
  };

  const handleRemoveVariant = (index) => {
    const updated = formData.variants.filter((_, i) => i !== index);
    setFormData((prev) => ({ ...prev, variants: updated }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleProductSubmit({ ...formData, companyId: selectedCompany?.id });
  };

  const handleCancel = () => {
    setShowProductForm(false);
    setEditingProduct(null);
    resetForm();
  };

  return (
    <div
      className={`modal fade ${showProductForm ? "show d-block" : ""}`}
      tabIndex="-1"
      role="dialog"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div
        className="modal-dialog modal-lg modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">
              {product ? "Edit Product" : "Add Product"}
            </h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCancel}
            ></button>
          </div>

          <div className="modal-body modal-body-scroll">
            <form onSubmit={handleSubmit}>
              <div className="row">
                {/* Product Name */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="name" className="form-label">
                    Product Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter Product Name"
                    required
                  />
                </div>

                {/* Model */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="model" className="form-label">
                    Model
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="model"
                    name="model"
                    value={formData.model}
                    onChange={handleInputChange}
                    placeholder="Enter Model"
                  />
                </div>

                {/* Short Description */}
                <div className="col-12 mb-3">
                  <label htmlFor="short_description" className="form-label">
                    Short Description
                  </label>
                  <textarea
                    className="form-control"
                    id="short_description"
                    name="short_description"
                    rows="2"
                    value={formData.short_description}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Long Description */}
                <div className="col-12 mb-3">
                  <label htmlFor="long_description" className="form-label">
                    Long Description
                  </label>
                  <textarea
                    className="form-control"
                    id="long_description"
                    name="long_description"
                    rows="3"
                    value={formData.long_description}
                    onChange={handleInputChange}
                  />
                </div>

                {/* Base Price */}
                <div className="col-md-6 mb-3">
                  <label htmlFor="price" className="form-label">
                    Base Price
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    id="price"
                    name="price"
                    step="0.01"
                    value={formData.price}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>

              {/* Variants */}
              <div className="mb-3">
                <label className="form-label">Variants</label>
                {formData.variants.map((variant, idx) => (
                  <div key={idx} className="d-flex gap-2 mb-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Variant Name"
                      value={variant.name}
                      onChange={(e) =>
                        handleVariantChange(idx, "name", e.target.value)
                      }
                    />
                    <input
                      type="number"
                      className="form-control"
                      placeholder="Variant Price"
                      step="0.01"
                      value={variant.price}
                      onChange={(e) =>
                        handleVariantChange(idx, "price", e.target.value)
                      }
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Max Discount (e.g. 5% or 1000)"
                      value={variant.max_discount || ""}
                      onChange={(e) =>
                        handleVariantChange(idx, "max_discount", e.target.value)
                      }
                    />
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      onClick={() => handleRemoveVariant(idx)}
                    >
                      Remove
                    </button>
                  </div>
                ))}
                <button
                  type="button"
                  className="btn btn-outline-primary w-100"
                  onClick={handleAddVariant}
                >
                  Add Variant
                </button>
              </div>
            </form>
          </div>

          <div className="modal-footer d-flex justify-content-end gap-3 p-3 mt-3">
            <button
              type="button"
              className="btn bg-danger-subtle text-danger px-4"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary px-4"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading
                ? "Saving..."
                : product
                ? "Update Product"
                : "Save Product"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductFormModal;
